const initialState = {
	data: [],
	total: 0,
	params: {},
	selectedPromotionCampaign: {},
	sidebarOpen: false,
	sidebarStatus: 'add',
}

const promotioncampaign = (state = initialState, action) => {
	switch (action.type) {
		case 'PROMOTIONCAMPAIGN_GET_DATA':
			return {
				...state,
				data: action.data,
				total: action.total,
				params: action.params,
			}
		case 'PROMOTIONCAMPAIGN_ADD_DATA':
			return {
				...state,
				data: [...state.data, action.data],
				total: state.total + 1,
			}
		case 'PROMOTIONCAMPAIGN_UPDATE_DATA':
			return {
				...state,
				data: state.data.map((item) => (item.id === action.index ? action.data : item)),
			}
		case 'PROMOTIONCAMPAIGN_DEL_DATA':
			return {
				...state,
				data: state.data.filter((item) => item.id !== action.index),
				total: state.total - 1,
			}
		case 'PROMOTIONCAMPAIGN_GET_CURRENT':
			return {
				...state,
				selectedPromotionCampaign: action.selectedPromotionCampaign,
			}
		case 'PROMOTIONCAMPAIGN_SET_SIDEBAR':
			return {
				...state,
				sidebarStatus: action.status,
				sidebarOpen: !state.sidebarOpen,
			}
		default:
			return state
	}
}

export default promotioncampaign
